import { connect } from 'react-redux'
import { isSubmitting } from 'redux-form'

import { FORM_NAME } from '../../Form'

import Component from './Component'

const mapStateToProps = (state) => ({
  submitting: isSubmitting(FORM_NAME)(state),
})

const actionCreators = {}

export default connect(mapStateToProps, actionCreators)(Component)